export const CONFIG_ELEM_ID = 'awsma-config';
